import dayjs from 'dayjs';
import { Select } from '@/components/common/SelectField';
import { useDatePickerContext } from '../../hooks/use-date-picker-context';

export function TimeSelect() {
  const { value, onChange, timeSlots, shouldDisableTime } = useDatePickerContext();
  const currentMinutes = dayjs(value).minute();
  const currentHours = dayjs(value).hour();

  return (
    <Select
      value={currentMinutes + currentHours * 60}
      onChange={({ value: totalMinutes }) => {
        const newDate = dayjs(value)
          .hour(0)
          .minute(0)
          .second(0)
          .millisecond(0)
          .add(totalMinutes, 'minute')
          .toDate();

        onChange(newDate);
      }}
      options={timeSlots.map((minutes) => ({
        value: minutes,
        label: dayjs().hour(0).minute(minutes).format('HH:mm'),
        disabled: shouldDisableTime?.(minutes),
      }))}
      emptyValueLabel="Select time"
    />
  );
}
